import { isEmpty } from 'lodash';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import getAddressFormatted from './getAddressFormatted';

const line = '*----------------------------------*%0D';

const header = (data: IOrder) => {
  return `
*${data.company_name}*%0D
${line}
Meu nome é ${data.name}%0D
contato ${data.whatsapp}%0D
${line}
*Pedido: N°${data.code}*%0D
${line}`;
};

const addressFormatted = (order: IOrder) => {
  if (!isEmpty(order.address) && order.address.road) {
    return `
*Endereço da Entrega*%0D
${getAddressFormatted(order.address)}`;
  }

  if (!isEmpty(order.address) && !order.address.road) {
    return `
*Endereço da Entrega*%0D
${order.address}
    `;
  }

  if (isEmpty(order.address)) {
    return `
*Endereço da Entrega*%0D
%0D
Retirada no Local%0D`;
  }
};

export default function getOrderDetails2(data: IOrder): string {
  let products_txt = '';
  let totals_txt = '';

  data.products.forEach(item => {
    const value = getCurrencyFormatted(parseFloat(`${item.value}`));
    const itemSubtotal = getCurrencyFormatted(
      parseFloat(item.value) * item.quantity,
    );

    if (item.measure === 'KG') {
      products_txt += `*${item.quantity.toFixed(3)}kg - ${item.name}*%0D`;
    } else {
      products_txt += `*${item.quantity}x - ${item.name}*%0D`;
    }

    products_txt += `(${value})%0D`;
    products_txt += `${itemSubtotal}%0D`.padStart(45, ' ');

    if (item.complements && item.complements.length > 0) {
      item.complements.forEach(complement => {
        products_txt += `*${complement.quantity}x - ${complement.item.name}*%0D`;
      });
    }

    products_txt += line;
  });

  totals_txt += '*Subtotal:';
  totals_txt += `${getCurrencyFormatted(data.subtotal)}*%0D`.padStart(30, ' ');

  totals_txt += '*Entrega:';
  totals_txt += `${getCurrencyFormatted(data.shippingCost)}*%0D`.padStart(
    30,
    ' ',
  );

  totals_txt += '*Total:';
  totals_txt += `${getCurrencyFormatted(data.total)}*%0D`.padStart(35, ' ');

  return `
${header(data)}
${products_txt}
${totals_txt}
${line}
*Pagamento:           ${data.paymentMethod}*%0D
${line}
${addressFormatted(data)}%0D
*----------------------------------*%0D
                  *Tecnologia*%0D
    *www.tem-pedido.web.app*%0D`;
}
